import React from "react";
import Uploady from "@rpldy/uploady";
import UploadPreview from "@rpldy/upload-preview";
import UploadButton from "@rpldy/upload-button";
import "./LoadImage.css"
import {
  useItemFinishListener,
  useItemProgressListener,
  useItemStartListener
} from "@rpldy/uploady";
const UploadImageResponse = ({
  setImgPredict,
  loading,
  setLoading,
  setImgSrc,
  setImgUpload,
}) => {
 
  useItemProgressListener((item)=> {
    setLoading(true);
  });

  useItemStartListener( (item)=>{

    let dataUrl = URL.createObjectURL(item.file)
    setImgSrc(dataUrl)
    setImgUpload(item.file)
  })
  useItemFinishListener(async (item) => {
    // let tmp = "data:image/png;base64," + item.uploadResponse.data.encoded_img;
    let tmpRmBg = "data:image/png;base64," + item.uploadResponse.data.predict;
    setImgPredict(tmpRmBg);
    setLoading(false);
  });

  return (
    <UploadButton extraProps={{ disabled: loading }} className="uploader">
      <i
        className="fa fa-upload"
        aria-hidden="true"
        style={{marginRight :"5px",marginLeft :"5px"}}
      ></i>
      Upload images
    </UploadButton>
  );
};

export default function LoadImage({
  setImgPredict,
  loading,
  setLoading,
  setImgSrc,
  setImgUpload,
  
}) {
  return (
    <Uploady
      method="POST"
      destination={{
        url: "http://127.0.0.1:8000/img",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "X-Requested-With",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
      }}
    >
      <UploadImageResponse
        setImgPredict={setImgPredict}
        loading={loading}
        setLoading={setLoading}
        setImgSrc={setImgSrc}
        setImgUpload={setImgUpload}
      />
    </Uploady>
  );
}
